import { ArrowRight } from "lucide-react";

interface SuggestionChipsProps {
  suggestions: string[];
  onClick: (text: string) => void;
}

export function SuggestionChips({ suggestions, onClick }: SuggestionChipsProps): React.ReactElement {
  return (
    <div className="flex flex-wrap gap-1.5 pt-1.5" data-testid="agent-suggestion-chips">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          type="button"
          onClick={() => onClick(suggestion)}
          className="inline-flex items-center gap-1 rounded-full border border-primary/20 bg-primary/5 px-3 py-1 text-xs text-primary hover:bg-primary/10 hover:border-primary/40 transition-colors cursor-pointer"
          data-testid="agent-suggestion-chip"
        >
          {suggestion}
          <ArrowRight className="h-3 w-3 opacity-50" />
        </button>
      ))}
    </div>
  );
}
